import Header from "@/components/Header";
import Footer from "@/components/Footer";

/**
 * LegalPage — thin wrapper that keeps every static/legal page typographically
 * consistent without redesigning anything. Pass a title + children.
 */
export default function LegalPage({ title, lastUpdated = "February 2026", testId, children }) {
  return (
    <div className="min-h-screen" data-testid={testId}>
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 pt-16 pb-24">
        <div className="chip" data-testid="legal-chip">
          <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" /> Last updated · {lastUpdated}
        </div>
        <h1 className="font-display font-black text-4xl md:text-5xl tracking-tight text-zinc-900 mt-6">
          {title}
        </h1>
        <div
          className="prose prose-zinc max-w-none mt-8
            prose-headings:font-display prose-headings:font-black prose-headings:tracking-tight
            prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-3
            prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-2
            prose-p:text-zinc-700 prose-li:text-zinc-700
            prose-a:text-indigo-600 prose-a:no-underline hover:prose-a:underline
            prose-strong:text-zinc-900"
        >
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
